(() => {
  const ICE_BUNDLES = [
    { label: "6", handle: "ib-6", id: "48064623083779", qty: 6, imageUrl: "https://cdn.shopify.com/s/files/1/0609/2141/3891/files/6_Pack_46d031be-449d-4db8-b860-7afeabbeb4cf.png?v=1778783621" },
    { label: "9", handle: "ib-9", id: "48138351051011", qty: 9, imageUrl: "https://cdn.shopify.com/s/files/1/0609/2141/3891/files/9_Pack_c5b86d04-4319-421f-b203-c4357581252e.png?v=1778783621" },
    { label: "12", handle: "ib-12", id: "48064636158211", qty: 12, imageUrl: "https://cdn.shopify.com/s/files/1/0609/2141/3891/files/12_Pack_a2da260d-1c7c-4a06-9dca-31dc128631bd.png?v=1778783621" },
  ];

  const BADGES = {
    "48138351051011": "פופולרי",
    "48064636158211": "הכי משתלם",
  };

  const root = document.getElementById("hlIceAddonRoot");
  if (!root) return;

  const mainEl = document.getElementById("hl-main-product-json");
  if (!mainEl) return;

  let chillpod;
  try {
    chillpod = JSON.parse(mainEl.textContent);
  } catch {
    return;
  }

  const bundleDataMap = new Map();

  for (const bundle of ICE_BUNDLES) {
    const bundleEl = document.getElementById(`hl-ice-bundle-product-json-${bundle.handle}`);
    if (!bundleEl) continue;

    try {
      const product = JSON.parse(bundleEl.textContent);
      const variant =
        (product?.variants || []).find((v) => String(v.id) === String(bundle.id)) ||
        product?.variants?.[0];

      let imageUrl = null;
      if (variant?.image_id) {
        const matchedImage = (product?.images || []).find((img) => img.id === variant.image_id);
        if (matchedImage) imageUrl = matchedImage.src;
      }
      if (!imageUrl) {
        imageUrl = product?.featured_image || product?.images?.[0]?.src || null;
      }

      if (variant) {
        bundleDataMap.set(String(bundle.id), {
          price: Number(variant.price) || 0,
          compare_at_price: Number(variant.compare_at_price || 0),
          imageUrl,
          available: variant.available !== false,
        });
      }
    } catch {
      // ignore
    }
  }

  bundleDataMap.forEach((data) => {
    if (data.imageUrl) {
      const preloadImg = new Image();
      preloadImg.src = data.imageUrl;
    }
  });

  const chillpodVariant = chillpod?.variants?.[0];
  const chillpodVariantId = chillpodVariant ? Number(chillpodVariant.id) : null;
  const chillpodPriceCents = chillpodVariant ? Number(chillpodVariant.price) : 0;
  const chillpodCompareCents =
    chillpodVariant && chillpodVariant.compare_at_price
      ? Number(chillpodVariant.compare_at_price)
      : 0;

  const check          = document.getElementById("hlIceCheck");
  const pillsContainer = document.getElementById("hlIcePills");
  const icePriceEl     = document.getElementById("hlIcePrice");
  const iceCompareEl   = document.getElementById("hlIceCompareAt");
  const perUnitEl      = document.getElementById("hlIcePerUnit");
  const totalEl        = document.getElementById("hlTotalPrice");
  const compareEl      = document.getElementById("hlTotalCompareAt");
  const installmentsEl = document.getElementById("hlInstallments");
  const addBtn         = document.getElementById("hlAddBothToCart");
  const cardEl         = document.getElementById("hlIceCard");
  const iceImgEl       = root.querySelector(".hl-ice-image img");
  const badgeEl        = document.getElementById("hlIceBadge");

  if (
    !check || !pillsContainer || !icePriceEl || !iceCompareEl ||
    !perUnitEl || !totalEl || !compareEl || !installmentsEl ||
    !addBtn || !chillpodVariantId || !cardEl
  ) return;

  const money  = (cents)   => "₪" + Math.round(cents / 100);
  const money2 = (shekels) => "₪" + Number(shekels).toFixed(2);

  // ── Sold-out check ─────────────────────────────────────────────
  const allSoldOut = ICE_BUNDLES.every((bundle) => {
    const data = bundleDataMap.get(String(bundle.id));
    return !data || !data.available;
  });

  if (allSoldOut) {
    cardEl.classList.add("is-sold-out");

    // Render pills as disabled (visible but not interactive)
    pillsContainer.innerHTML = ICE_BUNDLES.map((bundle) => `
      <button
        type="button"
        class="hl-ice-pill"
        data-id="${bundle.id}"
        disabled
        aria-disabled="true"
      >${bundle.label}</button>
    `).join("");

    // Show the sold-out label in the header
    const soldOutLabel = document.getElementById("hlIceSoldOutLabel");
    if (soldOutLabel) soldOutLabel.style.display = "inline-block";

    // Render price info from the first bundle for context
    const firstBundle = ICE_BUNDLES[0];
    const firstData = bundleDataMap.get(String(firstBundle.id));
    if (firstData) {
      if (iceImgEl) iceImgEl.src = firstBundle.imageUrl || firstData.imageUrl;
      icePriceEl.textContent = money(firstData.price);

      if (firstData.compare_at_price > firstData.price) {
        iceCompareEl.style.display = "inline";
        iceCompareEl.textContent = money(firstData.compare_at_price);
      } else {
        iceCompareEl.style.display = "none";
      }

      perUnitEl.textContent = `${money2((firstData.price / 100) / firstBundle.qty)} ליחידה`;
    }

    totalEl.textContent = money(chillpodPriceCents);

    if (chillpodCompareCents > chillpodPriceCents) {
      compareEl.style.display = "block";
      compareEl.textContent = money(chillpodCompareCents);
    } else {
      compareEl.style.display = "none";
    }

    const perPayment = (chillpodPriceCents / 100) / 3;
    installmentsEl.innerHTML = `או <strong>₪${perPayment.toFixed(2)}</strong> ב-3 תשלומים ללא ריבית`;

    // Add to cart adds only the chillpod
    addBtn.addEventListener("click", async () => {
      addBtn.disabled = true;
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: chillpodVariantId, quantity: 1 }] }),
        });
        if (!res.ok) throw new Error("cart/add failed");
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:updated"));
        document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
        document.dispatchEvent(new CustomEvent("product:added"));
      } catch (e) {
        console.error(e);
      } finally {
        addBtn.disabled = false;
      }
    });

  } else {
    // ── Normal (in-stock) flow ──────────────────────────────────

    let selectedId = String(ICE_BUNDLES[0].id);

    pillsContainer.innerHTML = ICE_BUNDLES.map((bundle) => `
      <button
        type="button"
        class="hl-ice-pill${String(bundle.id) === selectedId ? " is-active" : ""}"
        data-id="${bundle.id}"
        aria-pressed="${String(bundle.id) === selectedId ? "true" : "false"}"
      >${bundle.label}</button>
    `).join("");

    pillsContainer.addEventListener("click", (e) => {
      e.stopPropagation();
      const pill = e.target.closest(".hl-ice-pill");
      if (!pill) return;
      selectedId = pill.dataset.id;
      pillsContainer.querySelectorAll(".hl-ice-pill").forEach((p) => {
        const active = p.dataset.id === selectedId;
        p.classList.toggle("is-active", active);
        p.setAttribute("aria-pressed", active ? "true" : "false");
      });
      update();
    });

    let enabled = false;

    const syncUI = () => {
      check.setAttribute("aria-pressed", enabled ? "true" : "false");
      cardEl.classList.toggle("is-selected", enabled);
    };

    const update = () => {
      const bundleMeta = ICE_BUNDLES.find((item) => String(item.id) === selectedId);
      const bundleData = bundleDataMap.get(selectedId);

      if (!bundleMeta || !bundleData) {
        icePriceEl.textContent = "";
        iceCompareEl.style.display = "none";
        iceCompareEl.textContent = "";
        perUnitEl.textContent = "";
        return;
      }

      if (iceImgEl) {
        iceImgEl.src = bundleMeta.imageUrl || bundleData.imageUrl;
      }

      if (badgeEl) {
        const label = BADGES[selectedId];
        if (label) {
          badgeEl.textContent = label;
          badgeEl.style.display = "block";
        } else {
          badgeEl.style.display = "none";
        }
      }

      const iceCents        = bundleData.price;
      const iceCompareCents = bundleData.compare_at_price;
      const qty             = bundleMeta.qty || 1;

      icePriceEl.textContent = money(iceCents);

      if (iceCompareCents > iceCents) {
        iceCompareEl.style.display = "inline";
        iceCompareEl.textContent = money(iceCompareCents);
      } else {
        iceCompareEl.style.display = "none";
        iceCompareEl.textContent = "";
      }

      perUnitEl.textContent = `${money2((iceCents / 100) / qty)} ליחידה`;

      totalEl.textContent = money(chillpodPriceCents);

      if (chillpodCompareCents > chillpodPriceCents) {
        compareEl.style.display = "block";
        compareEl.textContent = money(chillpodCompareCents);
      } else {
        compareEl.style.display = "none";
        compareEl.textContent = "";
      }

      const perPayment = (chillpodPriceCents / 100) / 3;
      installmentsEl.innerHTML = `או <strong>₪${perPayment.toFixed(2)}</strong> ב-3 תשלומים ללא ריבית`;
    };

    const toggleEnabled = () => {
      enabled = !enabled;
      syncUI();
      update();
    };

    check.addEventListener("click", (e) => {
      e.stopPropagation();
      toggleEnabled();
    });

    cardEl.addEventListener("click", (e) => {
      if (e.target.closest(".hl-ice-select-wrap, select, option")) return;
      toggleEnabled();
    });

    cardEl.addEventListener("keydown", (e) => {
      if (document.activeElement === cardEl.querySelector("select")) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleEnabled();
      }
    });

    syncUI();
    update();

    addBtn.addEventListener("click", async () => {
      addBtn.disabled = true;
      const items = [{ id: chillpodVariantId, quantity: 1 }];
      if (enabled) items.push({ id: Number(selectedId), quantity: 1 });

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error("cart/add failed");
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:updated"));
        document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
        document.dispatchEvent(new CustomEvent("product:added"));
      } catch (e) {
        console.error(e);
      } finally {
        addBtn.disabled = false;
      }
    });
  }

  // ── Details modal ──────────────────────────────────────────────
  const detailsBtn   = document.getElementById("hlIceDetailsBtn");
  const modalOverlay = document.getElementById("hlIceModalOverlay");
  const modalClose   = document.getElementById("hlIceModalClose");

  if (detailsBtn && modalOverlay && modalClose) {

    const openModal = () => {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
      modalOverlay.classList.add("is-open");
      modalOverlay.setAttribute("aria-hidden", "false");
      modalClose.focus();
    };

    const closeModal = () => {
      const scrollY = Math.abs(parseInt(document.body.style.top || "0"));
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollY);
      modalOverlay.classList.remove("is-open");
      modalOverlay.setAttribute("aria-hidden", "true");
      detailsBtn.focus();
    };

    detailsBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      openModal();
    });

    modalClose.addEventListener("click", closeModal);

    modalOverlay.addEventListener("click", (e) => {
      if (e.target === modalOverlay) closeModal();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modalOverlay.classList.contains("is-open")) closeModal();
    });
  }

  // ── Carousel ───────────────────────────────────────────────────
  const track    = document.getElementById("hlIceCarouselTrack");
  const prevBtn  = document.getElementById("hlIceCarouselPrev");
  const nextBtn  = document.getElementById("hlIceCarouselNext");
  const dotsWrap = document.getElementById("hlIceCarouselDots");

  if (track) {
    const slides = track.querySelectorAll(".hl-ice-carousel-slide");
    const total  = slides.length;
    let current  = 0;

    const dots = dotsWrap ? dotsWrap.querySelectorAll(".hl-ice-carousel-dot") : [];

    const goTo = (index) => {
      current = Math.max(0, Math.min(index, total - 1));
      track.style.transform = `translateX(${-current * 100}%)`;

      dots.forEach((d, i) => d.classList.toggle("is-active", i === current));

      if (prevBtn) prevBtn.classList.toggle("is-hidden", current === 0);
      if (nextBtn) nextBtn.classList.toggle("is-hidden", current === total - 1);
    };

    if (prevBtn) prevBtn.addEventListener("click", () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener("click", () => goTo(current + 1));

    dots.forEach((dot) => {
      dot.addEventListener("click", () => goTo(Number(dot.dataset.index)));
    });

    let touchStartX = 0;
    let touchDeltaX = 0;

    track.addEventListener("touchstart", (e) => {
      touchStartX = e.touches[0].clientX;
      touchDeltaX = 0;
      track.style.transition = "none";
    }, { passive: true });

    track.addEventListener("touchmove", (e) => {
      touchDeltaX = e.touches[0].clientX - touchStartX;
      const offset = -(current * 100) + (touchDeltaX / track.parentElement.offsetWidth) * 100;
      track.style.transform = `translateX(${offset}%)`;
    }, { passive: true });

    track.addEventListener("touchend", () => {
      track.style.transition = "";
      if (touchDeltaX < -40) goTo(current + 1);
      else if (touchDeltaX > 40) goTo(current - 1);
      else goTo(current);
    });

    goTo(0);
  }

})();